// Matches the @bui-token-screen-md design token (768px). Originally added because a value
// import from @btnet/blueprint-design-tokens failed to resolve in CI (ado-285796) — that's
// now fixed, and new code should import BuiTokenScreenMd from that package directly instead
// of adding a new consumer here (see BTPeek/BTRail, ado-286805). This constant stays only for
// its existing consumers (BTButton, ResearchPreviewLayout); migrating them off it, and
// BTSplitButton's own separately-declared `MD_BREAKPOINT = 768`, is unrelated cleanup.
export const MD_BREAKPOINT = 768;
